<script setup>
import { shallowRef, watch } from "vue";

import BaseTooltip from "./BaseTooltip.vue";
import SvgLoadingPlaceholder from "./SvgLoadingPlaceholder.vue";
import { loadIcon } from "./svg-icon-loader";

defineOptions({ inheritAttrs: false });

const props = defineProps({
  name: { type: String, required: true },
  tooltip: { type: String, default: undefined },
});

const icon = shallowRef();

// the tooltip mounts with the loaded svg: reka keeps the element it first anchored to
watch(
  () => props.name,
  (name) => {
    icon.value = undefined;
    loadIcon(name).then((component) => {
      if (name === props.name) icon.value = component;
    });
  },
  { immediate: true },
);
</script>

<template>
  <SvgLoadingPlaceholder v-if="!icon" v-bind="$attrs" />
  <BaseTooltip v-else-if="tooltip" :text="tooltip">
    <component :is="icon" role="img" :aria-label="tooltip" tabindex="0" v-bind="$attrs" />
  </BaseTooltip>
  <component :is="icon" v-else v-bind="$attrs" />
</template>
